import React, { FC, useEffect } from 'react';
import classNames from 'classnames';
import { RouteComponentProps } from 'react-router';
import styles from './assets/payroll-edit-screen.module.scss';
import Loader from 'src/components/Loader';
import RoleLayout from 'src/components/layout/RoleLayout';
//import Form from '../../components/PayrollForm';
import { IPayroll } from 'src/types/payroll';

export interface StateProps {
    payroll: IPayroll | null;
    inProgress: boolean;
}

export interface DispatchProps {
    getData: (id: string | number) => void;
}

interface RouteParams {
    id: string;
}

export interface OwnProps extends RouteComponentProps<RouteParams> {}

export interface Props extends StateProps, DispatchProps, OwnProps {}

const PayrollEditScreen: FC<Props> = (props: Props) => {
    const {
        payroll,
        inProgress,
        match: {
            params: { id },
        },
        getData,
    } = props;

    useEffect(() => {
        if (!payroll || payroll.id !== id) {
            getData(id);
        }
        // eslint-disable-next-line
    }, [getData, id]);

    if (!payroll || inProgress) {
        return <Loader />;
    }

    return (
        <RoleLayout>
            <div>
                <h2>PAYROLLS {`>`} EDIT PAYROLL</h2>
            </div>
            <div className={classNames(styles.editWrap)}>{/*  <Form initialValues={{ ...payroll }} />*/}</div>
        </RoleLayout>
    );
};
export default PayrollEditScreen;
